const imageIcon = "/stocks/assets/image";

export const logo = `${imageIcon}/logo.jpg`;
export const placeholder = `${imageIcon}/placeholder.svg`;
export const openAILogo = `${imageIcon}/openAILogo.svg`;
export const queLogo = `${imageIcon}/queLogo.svg`;
export const arrow2 = `${imageIcon}/arrow2.svg`;
export const blueSearch = `${imageIcon}/blue-search.png`;
export const greySearch = `${imageIcon}/greySearch.svg`;
export const logoSvg = `${imageIcon}/logo.svg`;
export const searchIcon = `${imageIcon}/search-icon.svg`;
export const searchIcon2 = `${imageIcon}/search.svg`;
export const searchIcon3 = `${imageIcon}/search1.svg`;
export const logoSvg2 = `${imageIcon}/Logo 2.svg`;
export const hoverAdvance = `${imageIcon}/hoverAdvance.svg`;
export const Vector = `${imageIcon}/Vector.svg`;
export const rectangle22 = `${imageIcon}/Rectangle 22.png`;
export const LockBlue = `${imageIcon}/LockBlue.svg`;
